// extracted by mini-css-extract-plugin
module.exports = {"templatePageContainer":"TemplatesOverviewPage_templatePageContainer__3ukz5"};